import { AutoEletric } from '../../shared/model/auto-eletric';
import { Technician } from '../../shared/model/technician';

export class Scheduling {
  constructor(public id?,
              public autoEletricChosenByArgos?,
              public creationDate?,
              public scheduleDate?,
              public lastUpdateDate?,
              public observation?,
              public technicianContact?,
              public customerContact?,
              public autoEletric?: AutoEletric,
              public technician?: Technician,
              public isEditable?,
              public isVisible?,
              public canView?,
              public canEdit?,
              public editable?,
              public argosUser?,
              public associateAutoeletric?) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/scheduling.ts